import TrackerPanel from "@/ui/action-panel/TrackerPanel.vue";
import {ActionPanelInstance} from "@t/ui/ActionPanel.ts";

export function resoveActionPanelComponent(type: string) {
	switch (type) {
		case "tracker":
			return TrackerPanel;
	}
	throw "Invalid action panel type " + type;
}

export function panelBinding(panel:ActionPanelInstance<any>):Record<string, any> {
	if (panel?.bind) return panel.bind
	return {};
}